import React from 'react';
import PropTypes from 'prop-types';
import { TableCell } from '@mui/material';
import { DateTime } from '@ts-private/rocket-extensions';

export const DateTimeFilterCell = ({ filter, onFilter, id }) => {
  return (
    <TableCell>
      <DateTime
        id={id}
        format={'dd/MM/yyyy'}
        fullWidth
        value={filter?.value}
        onChange={value => onFilter(value ? { value } : null)}
        timeFormat={false}
        disabled={false}
        required
      />
    </TableCell>
  );
};

DateTimeFilterCell.propTypes = {
  filter: PropTypes.object,
  onFilter: PropTypes.func.isRequired,
  id: PropTypes.string
};

export default DateTimeFilterCell;
